import React from 'react';
import { Col, Row } from 'react-bootstrap';
const ProjectMe = () => {
    return (
        <Row xs={1} md={1} lg={2} className='py-5 g-5'>
            <Col>
                <div className="project">
                    <img src="https://i.ibb.co/dDNC43Z/screencapture-developerfarid-github-io-project-02-2022-03-20-12-31-49-min.png" className='img-fluid'  alt="" />
                </div>
            </Col>
            <Col>
                <div className="project">
                    <img src="https://i.ibb.co/yffhpfP/screencapture-developerfarid-github-io-section-001-2022-03-20-12-25-36-1.png" className='img-fluid'  alt="" />
                </div>
            </Col>
            <Col>
                <div className="project">
                    <img src="https://i.ibb.co/WDy1d5L/screencapture-honda-cbr-bootstrap-assignment-developerfarid-netlify-app-2022-01-06-17-37-17.png" className='img-fluid'  alt="" />
                </div>
            </Col>
            <Col>
                <div className="project">
                    <img src="https://i.ibb.co/ChBKSx2/screencapture-developerfarid-github-io-morix-ful01-13-18-22-06.png" className='img-fluid'  alt="" />
                </div>
            </Col>
        </Row>
    );
};

export default ProjectMe;